import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["view", "label", "icon", "isLogo", "className", "tagName", "theme"];
import React from 'react';
import { cnBem, forwardRefWithTag } from '@carnica/utils';
import { Avatar, Text } from '@carnica/ui-kit';
import styles from "./styles.pcss";
var cnMenuItem = cnBem('menu-item', styles);
export var MenuItem = forwardRefWithTag(function (props, ref) {
  var _props$view = props.view,
    view = _props$view === void 0 ? 'accent' : _props$view,
    label = props.label,
    Icon = props.icon,
    isLogo = props.isLogo,
    className = props.className,
    _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'button' : _props$tagName,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'light' : _props$theme,
    otherProps = _objectWithoutProperties(props, _excluded);
  var Tag = tagName;
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cnMenuItem({
      view: view,
      theme: theme
    }, [className]),
    ref: ref
  }, otherProps, {
    "data-t-id": "ui-Menu"
  }), Icon && view === 'accent' && /*#__PURE__*/React.createElement(Avatar, _extends({
    className: cnMenuItem('avatar', {
      logo: isLogo
    }),
    size: "l"
  }, isLogo ? {
    logo: Icon
  } : {
    icon: Icon
  })), /*#__PURE__*/React.createElement(Text, {
    className: cnMenuItem('label'),
    color: theme === 'light' ? 'primary-invert' : 'primary',
    variant: "body-small"
  }, label), Icon && view === 'default' && /*#__PURE__*/React.createElement(Icon, {
    className: cnMenuItem('icon'),
    size: "xs"
  }));
});